
import { SaleLayoutTableLine } from "@/utils/sale-layouts/table-line";
import Vue from "vue";
import AppFieldsEdit from "./FieldsWithSeperateStylesEdit.vue";

export default Vue.extend({
	props: {
		line: Array as () => SaleLayoutTableLine[],
		title: String
	},
	computed: {
		newItemConstructor():Function{
			return ()=>new SaleLayoutTableLine();
		}
	},
	components: {
		AppFieldsEdit
	},
	i18nEx: {
		componentPrefix: "components.sale-layout-editor"
	}
});
